import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import EventPopup from './components/EventPopup/EventPopup';
import HomePage from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import EventsPage from './pages/Events/Events';
import Registration from './pages/Registration/Registration';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import AdminLogin from './pages/AdminLogin/AdminLogin';
import NotFound from './pages/PageNotFound/NotFound';
import { getToken, getAdmin, setSession, clearSession, AUTH_LOGOUT_EVENT } from './api/authStorage';
import './styles/navbar.css';
import './App.css';

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => !!getToken());
  const [admin, setAdmin] = useState(() => getAdmin());

  const handleAdminLogin = (token, adminInfo) => {
    setSession(token, adminInfo);
    setAdmin(adminInfo);
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = () => {
    clearSession();
    setAdmin(null);
    setIsAdminAuthenticated(false);
  };

  useEffect(() => {
    window.addEventListener(AUTH_LOGOUT_EVENT, handleAdminLogout);
    return () => window.removeEventListener(AUTH_LOGOUT_EVENT, handleAdminLogout);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <Router>
      <div className="App">
        <EventPopup />
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route
              path="/admin-login"
              element={
                isAdminAuthenticated ? (
                  <Navigate to="/admin" replace />
                ) : (
                  <AdminLogin onLogin={handleAdminLogin} />
                )
              }
            />
            <Route
              path="/admin"
              element={
                isAdminAuthenticated ? (
                  <AdminPanel admin={admin} onLogout={handleAdminLogout} />
                ) : (
                  <Navigate to="/admin-login" replace />
                )
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
